import React, { useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { ColDef, ColumnState } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { GridContextWrapper } from "src/components/common/gridWrapper/GridContextWrapper";
import Grid_Select from "src/components/common/gridWrapper/Grid_Select";
import { PDA1130_R01Dto } from "./PDA1130_R01Dto";
import { aggridHeaderClass, pdaCellStyle } from "src/components/common/common";

interface PDA1130_R01TableProps {
  shippingOrderList: PDA1130_R01Dto[];
  onSelectOrder: (order: PDA1130_R01Dto) => void;
}

type ShippingOrderWithInserted = PDA1130_R01Dto & { inserted?: boolean };

const PDA1130_R01Table = ({ shippingOrderList, onSelectOrder }: PDA1130_R01TableProps) => {
  const gridRef = useRef<AgGridReact<ShippingOrderWithInserted>>(null);
  const gridWrapperRef = useRef<HTMLDivElement>(null);
  const [columnState, setColumnState] = React.useState<ColumnState[] | null>(null);
  const [hoveredRowIndex, setHoveredRowIndex] = useState<number | null>(null);

  const paddedGridData = useMemo(() => {
    return shippingOrderList.map(order => ({ ...order, inserted: false }));
  }, [shippingOrderList]);

  // 컬럼 정의 (이미지 기준)
  const columnDefs: ColDef<ShippingOrderWithInserted>[] = useMemo(() => [
    {
      headerName: "일자",
      field: "orderDate",
      valueGetter: (params) => params.data?.orderDate || "-",
      cellStyle: { textAlign: "center", ...pdaCellStyle },
      headerClass: aggridHeaderClass,
      flex: 0.7,
      minWidth: 80,
    },
    {
      headerName: "거래처",
      field: "customCd",
      valueGetter: (params) => params.data?.customCd || "-",
      cellStyle: { textAlign: "center", ...pdaCellStyle },
      headerClass: aggridHeaderClass,
      flex: 0.8,
      minWidth: 80,
    },
    {
      headerName: "상호",
      field: "custNm",
      valueGetter: (params) => params.data?.custNm || "-",
      cellStyle: { textAlign: "left", ...pdaCellStyle },
      headerClass: aggridHeaderClass,
      flex: 1.2,
      minWidth: 80,
    },
    {
      headerName: "출고품목",
      field: "shippingItems",
      valueGetter: (params) => params.data?.shippingItems || "-",
      cellStyle: { textAlign: "left", ...pdaCellStyle },
      headerClass: aggridHeaderClass,
      flex: 2,
      minWidth: 80,
    },
  ], []);

  const initSelected = () => {};

  return (
    <div className="flex-1 p-3 pt-2 flex w-full h-full flex-col overflow-hidden">
      <GridContextWrapper
        gridRef={gridRef}
        gridWrapperRef={gridWrapperRef}
        paddedGridData={paddedGridData}
        initSelected={initSelected}
        baseColumnDefs={columnDefs}
        setColumnState={setColumnState}
        localStorageKey="PDA1130_R01_ColumnState"
        enableDataHistory={false}
      >
        <div className="flex-1 w-full h-full min-h-0">
          <Grid_Select<ShippingOrderWithInserted>
            ref={gridRef}
            rowData={paddedGridData}
            columnDefs={columnDefs}
            rowSelection="single"
            onRowClicked={(event) => {
              if (event.data) {
                onSelectOrder(event.data);
              }
            }}
            setHoveredRowIndex={setHoveredRowIndex}
            columnStateKey="PDA1130_R01_ColumnState"
            setColumnState={setColumnState}
          />
        </div>
      </GridContextWrapper>
    </div>
  );
};

export default PDA1130_R01Table;
